<template>
	<PublicMenuLayoutV2>
		<template v-slot:nav-items>
			<b-nav-item class="my-auto">
				<router-link to="/opensalud360/empresas">
					<p>{{ $t('business') }}</p>
				</router-link>
			</b-nav-item>
			<b-nav-item class="my-auto" @click="goToOpensalud4allLanding" v-if="!inMx">
				<p>Opensalud4all</p>
			</b-nav-item>
			<b-nav-item class="my-auto">
				<router-link to="/">
					<p>{{ $t('patients') }}</p>
				</router-link>
			</b-nav-item>
		</template>
		<template v-slot:nav-btn-items>
			<b-nav-item class="my-auto d-none d-xl-block ml-0 ml-xl-2">
				<router-link to="/inicio-sesion">
					<ArrowButton :text="$t('login-wrd')" :action="() => { $router.push('/inicio-sesion') }" reverse :backgroundColor="BLUE_COLOUR" :textColor="WHITE_COLOUR" />
				</router-link>
			</b-nav-item>
		</template>
		<!-- <template v-slot:heading>
			<base-dialog v-model="primeDialog.visible" :okFn="async () => { primeDialog.visible = false }" :dontShowAgainCookie="primeDialog.cookie">
			
				<div class="text-center" v-html="$t('primeByOpensaludWarning')"></div>
				<b-row class="social-icons py-xl-5 mt-3" align-h="center">
					<b-col xl="4" sm="12" class="text-center">
						<a target="_blank" v-for="(link, index) in socialLinks" :href="link.href" :key="index">
						<img :src="link.src" :alt="link.alt" align-h="center"/>
						</a>
					</b-col>
				</b-row>
			</base-dialog>
		</template> -->
	</PublicMenuLayoutV2>
</template>

<script>
	import PublicMenuLayoutV2 from '@/components/layouts/PublicMenuLayoutV2'
	import ArrowButton from '@/components/base/buttons/ArrowButton'
	import { BNavItem } from 'bootstrap-vue'
	import { BLUE_COLOUR, WHITE_COLOUR } from '@/constants/colours'
	import BaseDialog from '@/components/base/BaseDialog'
	import { PRIME_BY_OPENSALUD_WARNING_COOKIE } from '@/constants/cookies'
	import { inMx } from '@/helpers/global.helpers'

	export default {
		name: 'OpensaludLayout',
		components: {
			BNavItem,
			PublicMenuLayoutV2,
			ArrowButton,
			BaseDialog
		},
		data () {
			return {
				inMx,
				BLUE_COLOUR,
				WHITE_COLOUR,
				primeDialog: {
					visible: true,
					cookie: PRIME_BY_OPENSALUD_WARNING_COOKIE
				},
				socialLinks: [
					{
					href: 'https://www.facebook.com/opensalud/',
					src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Facebook_blue.svg',
					alt: 'opensalud social facebook'
					},
					{
					href: 'https://www.instagram.com/opensalud/',
					src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Instagram_blue.svg',
					alt: 'opensalud social instagram'
					},
					{
					href: 'https://www.linkedin.com/company/10606222?trk=tyah&amp;trkInfo=clickedVertical%3Acompany%2CclickedEntityId%3A10606222%2Cidx%3A1-1-1%2CtarId%3A1461928785973%2Ctas%3Aopensalud',
					src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Linkedin_blue.svg',
					alt: 'opensalud social linkedin'
					},
					{
					href: 'https://www.twitter.com/opensalud',
					src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Twitter_blue.svg',
					alt: 'opensalud social twitter'
					}
				]
			}
		},
		methods: {
			goToOpensalud4allLanding () {
				window.location = 'https://opensalud4all.com/'
			}
		}
	}
</script>

<style  scoped lang="scss">
.social-icons a {
    margin-right: 1rem;
		margin-left: 1rem;
    display: inline-flex;

    img {
      transform: scale(1);
      transition-duration: .5s;
			max-width: 1.75rem;
    }


    &:hover {
      img {
        transform: scale(1.2);
        transition-duration: .5s;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/layouts/OpensaludProfesionalesLayout.vue